// @generated by protobuf-ts 2.9.4 with parameter long_type_string,generate_dependencies
// @generated from protobuf file "tts.proto" (package "speaker.beta2", syntax proto3)
// tslint:disable
import { ListOfVoices } from "./list_of_voices";
import { Empty } from "./google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Struct } from "./google/protobuf/struct";
import { AudioFormat } from "./audio_format";
/**
 * *
 * A request to synthesize a given text as spoken language.
 *
 * @generated from protobuf message speaker.beta2.TextToSpeechRequest
 */
export interface TextToSpeechRequest {
  /**
   * @generated from protobuf field: string text = 1;
   */
  text: string; // The utterance to be synthesized.
  /**
   * @generated from protobuf field: string language = 2;
   */
  language: string; // The desired language in which the utterance is to be synthesized.
  /**
   * @generated from protobuf field: string voice = 3;
   */
  voice: string; // (Optional) The name of the voice; if not given the service will choose the language default.
  /**
   * @generated from protobuf field: speaker.beta2.AudioFormat audio_format = 4;
   */
  audioFormat?: AudioFormat; // The desired audio data format in which the synthesized speech is to be returned.
  /**
   * @generated from protobuf field: float speech_rate = 5;
   */
  speechRate: number; // Speed rate of the synthesized speech; if unset (0.0) it will default to 1.0 which is the regular speed. Values above 1.0 will result in faster pace, vice vera for values below.
  /**
   * @generated from protobuf field: string flavor = 6;
   */
  flavor: string; // The name of the flavor.
  /**
   * @generated from protobuf field: bool debug = 15;
   */
  debug: boolean; // True, if debug information for this request should also be returned
  /**
   * @generated from protobuf field: string environment = 16;
   */
  environment: string; // Explicitly select a service environment
}
/**
 * *
 * The synthesized speech; may be a stream of these messages.
 *
 * @generated from protobuf message speaker.beta2.SynthesizedSpeech
 */
export interface SynthesizedSpeech {
  /**
   * @generated from protobuf field: bytes audio = 1;
   */
  audio: Uint8Array; // synthesized speech
  /**
   * @generated from protobuf field: string phoneme = 2;
   */
  phoneme: string; // (Optional) The generated phoneme
  /**
   * @generated from protobuf field: google.protobuf.Struct debug_info = 15;
   */
  debugInfo?: Struct; // Debug information needed to reconstruct the request in case of an error.
}
/**
 * @generated from protobuf message speaker.beta2.ListOfFlavors
 */
export interface ListOfFlavors {
  /**
   * @generated from protobuf field: repeated speaker.beta2.ListOfFlavors.Flavor flavors = 1;
   */
  flavors: ListOfFlavors_Flavor[]; // List of available flavors
}
/**
 * @generated from protobuf message speaker.beta2.ListOfFlavors.Flavor
 */
export interface ListOfFlavors_Flavor {
  /**
   * @generated from protobuf field: string name = 1;
   */
  name: string; // The name of the flavor
  /**
   * @generated from protobuf field: repeated speaker.beta2.ListOfFlavors.Flavor.Language languages = 2;
   */
  languages: ListOfFlavors_Flavor_Language[]; // List of languages this flavor has
  /**
   * @generated from protobuf field: string description = 3;
   */
  description: string; // A description of the flavor
}
/**
 * @generated from protobuf message speaker.beta2.ListOfFlavors.Flavor.Language
 */
export interface ListOfFlavors_Flavor_Language {
  /**
   * @generated from protobuf field: string name = 1;
   */
  name: string; // The BCP 47 tag for the language
  /**
   * @generated from protobuf field: repeated string voices = 2;
   */
  voices: string[]; // The voices supported by this flavor and language
}
// @generated message type with reflection information, may provide speed optimized methods
class TextToSpeechRequest$Type extends MessageType<TextToSpeechRequest> {
  constructor() {
    super("speaker.beta2.TextToSpeechRequest", [
      { no: 1, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
      { no: 2, name: "language", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
      { no: 3, name: "voice", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
      { no: 4, name: "audio_format", kind: "message", T: () => AudioFormat },
      { no: 5, name: "speech_rate", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
      { no: 6, name: "flavor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
      { no: 15, name: "debug", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
      {
        no: 16,
        name: "environment",
        kind: "scalar",
        T: 9 /*ScalarType.STRING*/,
      },
    ]);
  }
  create(value?: PartialMessage<TextToSpeechRequest>): TextToSpeechRequest {
    const message = globalThis.Object.create(this.messagePrototype!);
    message.text = "";
    message.language = "";
    message.voice = "";
    message.speechRate = 0;
    message.flavor = "";
    message.debug = false;
    message.environment = "";
    if (value !== undefined)
      reflectionMergePartial<TextToSpeechRequest>(this, message, value);
    return message;
  }
  internalBinaryRead(
    reader: IBinaryReader,
    length: number,
    options: BinaryReadOptions,
    target?: TextToSpeechRequest
  ): TextToSpeechRequest {
    let message = target ?? this.create(),
      end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string text */ 1:
          message.text = reader.string();
          break;
        case /* string language */ 2:
          message.language = reader.string();
          break;
        case /* string voice */ 3:
          message.voice = reader.string();
          break;
        case /* speaker.beta2.AudioFormat audio_format */ 4:
          message.audioFormat = AudioFormat.internalBinaryRead(
            reader,
            reader.uint32(),
            options,
            message.audioFormat
          );
          break;
        case /* float speech_rate */ 5:
          message.speechRate = reader.float();
          break;
        case /* string flavor */ 6:
          message.flavor = reader.string();
          break;
        case /* bool debug */ 15:
          message.debug = reader.bool();
          break;
        case /* string environment */ 16:
          message.environment = reader.string();
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(
              `Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`
            );
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(
              this.typeName,
              message,
              fieldNo,
              wireType,
              d
            );
      }
    }
    return message;
  }
  internalBinaryWrite(
    message: TextToSpeechRequest,
    writer: IBinaryWriter,
    options: BinaryWriteOptions
  ): IBinaryWriter {
    /* string text = 1; */
    if (message.text !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.text);
    /* string language = 2; */
    if (message.language !== "")
      writer.tag(2, WireType.LengthDelimited).string(message.language);
    /* string voice = 3; */
    if (message.voice !== "")
      writer.tag(3, WireType.LengthDelimited).string(message.voice);
    /* speaker.beta2.AudioFormat audio_format = 4; */
    if (message.audioFormat)
      AudioFormat.internalBinaryWrite(
        message.audioFormat,
        writer.tag(4, WireType.LengthDelimited).fork(),
        options
      ).join();
    /* float speech_rate = 5; */
    if (message.speechRate !== 0)
      writer.tag(5, WireType.Bit32).float(message.speechRate);
    /* string flavor = 6; */
    if (message.flavor !== "")
      writer.tag(6, WireType.LengthDelimited).string(message.flavor);
    /* bool debug = 15; */
    if (message.debug !== false)
      writer.tag(15, WireType.Varint).bool(message.debug);
    /* string environment = 16; */
    if (message.environment !== "")
      writer.tag(16, WireType.LengthDelimited).string(message.environment);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(
        this.typeName,
        message,
        writer
      );
    return writer;
  }
}
/**
 * @generated MessageType for protobuf message speaker.beta2.TextToSpeechRequest
 */
export const TextToSpeechRequest = new TextToSpeechRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SynthesizedSpeech$Type extends MessageType<SynthesizedSpeech> {
  constructor() {
    super("speaker.beta2.SynthesizedSpeech", [
      { no: 1, name: "audio", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
      { no: 2, name: "phoneme", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
      { no: 15, name: "debug_info", kind: "message", T: () => Struct },
    ]);
  }
  create(value?: PartialMessage<SynthesizedSpeech>): SynthesizedSpeech {
    const message = globalThis.Object.create(this.messagePrototype!);
    message.audio = new Uint8Array(0);
    message.phoneme = "";
    if (value !== undefined)
      reflectionMergePartial<SynthesizedSpeech>(this, message, value);
    return message;
  }
  internalBinaryRead(
    reader: IBinaryReader,
    length: number,
    options: BinaryReadOptions,
    target?: SynthesizedSpeech
  ): SynthesizedSpeech {
    let message = target ?? this.create(),
      end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* bytes audio */ 1:
          message.audio = reader.bytes();
          break;
        case /* string phoneme */ 2:
          message.phoneme = reader.string();
          break;
        case /* google.protobuf.Struct debug_info */ 15:
          message.debugInfo = Struct.internalBinaryRead(
            reader,
            reader.uint32(),
            options,
            message.debugInfo
          );
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(
              `Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`
            );
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(
              this.typeName,
              message,
              fieldNo,
              wireType,
              d
            );
      }
    }
    return message;
  }
  internalBinaryWrite(
    message: SynthesizedSpeech,
    writer: IBinaryWriter,
    options: BinaryWriteOptions
  ): IBinaryWriter {
    /* bytes audio = 1; */
    if (message.audio.length)
      writer.tag(1, WireType.LengthDelimited).bytes(message.audio);
    /* string phoneme = 2; */
    if (message.phoneme !== "")
      writer.tag(2, WireType.LengthDelimited).string(message.phoneme);
    /* google.protobuf.Struct debug_info = 15; */
    if (message.debugInfo)
      Struct.internalBinaryWrite(
        message.debugInfo,
        writer.tag(15, WireType.LengthDelimited).fork(),
        options
      ).join();
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(
        this.typeName,
        message,
        writer
      );
    return writer;
  }
}
/**
 * @generated MessageType for protobuf message speaker.beta2.SynthesizedSpeech
 */
export const SynthesizedSpeech = new SynthesizedSpeech$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOfFlavors$Type extends MessageType<ListOfFlavors> {
  constructor() {
    super("speaker.beta2.ListOfFlavors", [
      {
        no: 1,
        name: "flavors",
        kind: "message",
        repeat: 1 /*RepeatType.PACKED*/,
        T: () => ListOfFlavors_Flavor,
      },
    ]);
  }
  create(value?: PartialMessage<ListOfFlavors>): ListOfFlavors {
    const message = globalThis.Object.create(this.messagePrototype!);
    message.flavors = [];
    if (value !== undefined)
      reflectionMergePartial<ListOfFlavors>(this, message, value);
    return message;
  }
  internalBinaryRead(
    reader: IBinaryReader,
    length: number,
    options: BinaryReadOptions,
    target?: ListOfFlavors
  ): ListOfFlavors {
    let message = target ?? this.create(),
      end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* repeated speaker.beta2.ListOfFlavors.Flavor flavors */ 1:
          message.flavors.push(
            ListOfFlavors_Flavor.internalBinaryRead(
              reader,
              reader.uint32(),
              options
            )
          );
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(
              `Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`
            );
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(
              this.typeName,
              message,
              fieldNo,
              wireType,
              d
            );
      }
    }
    return message;
  }
  internalBinaryWrite(
    message: ListOfFlavors,
    writer: IBinaryWriter,
    options: BinaryWriteOptions
  ): IBinaryWriter {
    /* repeated speaker.beta2.ListOfFlavors.Flavor flavors = 1; */
    for (let i = 0; i < message.flavors.length; i++)
      ListOfFlavors_Flavor.internalBinaryWrite(
        message.flavors[i],
        writer.tag(1, WireType.LengthDelimited).fork(),
        options
      ).join();
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(
        this.typeName,
        message,
        writer
      );
    return writer;
  }
}
/**
 * @generated MessageType for protobuf message speaker.beta2.ListOfFlavors
 */
export const ListOfFlavors = new ListOfFlavors$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOfFlavors_Flavor$Type extends MessageType<ListOfFlavors_Flavor> {
  constructor() {
    super("speaker.beta2.ListOfFlavors.Flavor", [
      { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
      {
        no: 2,
        name: "languages",
        kind: "message",
        repeat: 1 /*RepeatType.PACKED*/,
        T: () => ListOfFlavors_Flavor_Language,
      },
      {
        no: 3,
        name: "description",
        kind: "scalar",
        T: 9 /*ScalarType.STRING*/,
      },
    ]);
  }
  create(value?: PartialMessage<ListOfFlavors_Flavor>): ListOfFlavors_Flavor {
    const message = globalThis.Object.create(this.messagePrototype!);
    message.name = "";
    message.languages = [];
    message.description = "";
    if (value !== undefined)
      reflectionMergePartial<ListOfFlavors_Flavor>(this, message, value);
    return message;
  }
  internalBinaryRead(
    reader: IBinaryReader,
    length: number,
    options: BinaryReadOptions,
    target?: ListOfFlavors_Flavor
  ): ListOfFlavors_Flavor {
    let message = target ?? this.create(),
      end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string name */ 1:
          message.name = reader.string();
          break;
        case /* repeated speaker.beta2.ListOfFlavors.Flavor.Language languages */ 2:
          message.languages.push(
            ListOfFlavors_Flavor_Language.internalBinaryRead(
              reader,
              reader.uint32(),
              options
            )
          );
          break;
        case /* string description */ 3:
          message.description = reader.string();
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(
              `Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`
            );
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(
              this.typeName,
              message,
              fieldNo,
              wireType,
              d
            );
      }
    }
    return message;
  }
  internalBinaryWrite(
    message: ListOfFlavors_Flavor,
    writer: IBinaryWriter,
    options: BinaryWriteOptions
  ): IBinaryWriter {
    /* string name = 1; */
    if (message.name !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.name);
    /* repeated speaker.beta2.ListOfFlavors.Flavor.Language languages = 2; */
    for (let i = 0; i < message.languages.length; i++)
      ListOfFlavors_Flavor_Language.internalBinaryWrite(
        message.languages[i],
        writer.tag(2, WireType.LengthDelimited).fork(),
        options
      ).join();
    /* string description = 3; */
    if (message.description !== "")
      writer.tag(3, WireType.LengthDelimited).string(message.description);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(
        this.typeName,
        message,
        writer
      );
    return writer;
  }
}
/**
 * @generated MessageType for protobuf message speaker.beta2.ListOfFlavors.Flavor
 */
export const ListOfFlavors_Flavor = new ListOfFlavors_Flavor$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOfFlavors_Flavor_Language$Type extends MessageType<ListOfFlavors_Flavor_Language> {
  constructor() {
    super("speaker.beta2.ListOfFlavors.Flavor.Language", [
      { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
      {
        no: 2,
        name: "voices",
        kind: "scalar",
        repeat: 2 /*RepeatType.UNPACKED*/,
        T: 9 /*ScalarType.STRING*/,
      },
    ]);
  }
  create(
    value?: PartialMessage<ListOfFlavors_Flavor_Language>
  ): ListOfFlavors_Flavor_Language {
    const message = globalThis.Object.create(this.messagePrototype!);
    message.name = "";
    message.voices = [];
    if (value !== undefined)
      reflectionMergePartial<ListOfFlavors_Flavor_Language>(
        this,
        message,
        value
      );
    return message;
  }
  internalBinaryRead(
    reader: IBinaryReader,
    length: number,
    options: BinaryReadOptions,
    target?: ListOfFlavors_Flavor_Language
  ): ListOfFlavors_Flavor_Language {
    let message = target ?? this.create(),
      end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string name */ 1:
          message.name = reader.string();
          break;
        case /* repeated string voices */ 2:
          message.voices.push(reader.string());
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(
              `Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`
            );
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(
              this.typeName,
              message,
              fieldNo,
              wireType,
              d
            );
      }
    }
    return message;
  }
  internalBinaryWrite(
    message: ListOfFlavors_Flavor_Language,
    writer: IBinaryWriter,
    options: BinaryWriteOptions
  ): IBinaryWriter {
    /* string name = 1; */
    if (message.name !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.name);
    /* repeated string voices = 2; */
    for (let i = 0; i < message.voices.length; i++)
      writer.tag(2, WireType.LengthDelimited).string(message.voices[i]);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(
        this.typeName,
        message,
        writer
      );
    return writer;
  }
}
/**
 * @generated MessageType for protobuf message speaker.beta2.ListOfFlavors.Flavor.Language
 */
export const ListOfFlavors_Flavor_Language =
  new ListOfFlavors_Flavor_Language$Type();
/**
 * @generated ServiceType for protobuf service speaker.beta2.TextToSpeech
 */
export const TextToSpeech = new ServiceType("speaker.beta2.TextToSpeech", [
  {
    name: "synthesize",
    serverStreaming: true,
    options: {},
    I: TextToSpeechRequest,
    O: SynthesizedSpeech,
  },
  { name: "enumerate", options: {}, I: Empty, O: ListOfFlavors },
  { name: "enumerateVoices", options: {}, I: Empty, O: ListOfVoices },
]);
